import { bindValidator } from "../validators";

const form = document.querySelector<HTMLFormElement>(".login__form");

if(form) {
    const validator = bindValidator(form);

    const emailFields = form.querySelectorAll<HTMLInputElement>('input[name="email"]');

    emailFields.forEach((field) => {
        field.addEventListener('blur', () => {
            field.value = field.value.trim();
        });
    });

    form?.addEventListener('submit', (e) => {
        emailFields.forEach((field) => {
            field.value = field.value.trim();
        });

        if(!validator.validate())
            e.preventDefault();
    })
}